module.exports = __webpack_public_path__ + "assets/a4b2686968f74a2c7238581df33777ea.mp3";